import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { connect } from 'react-redux';
import {
  setContent,
  logout,
  tryLogin,
  getCourses
} from '../actions/AuthAction';
import { getChatRooms } from '../actions/CoachAction';
import { Root } from '../components/Root';
import Dashboard from './Dashboard';
import Pro from './Pro.Container';
import Profile from '../components/Profile';
import Forum from './Forum';
import Home from '../components/Home';
// import redirectIntro from '../components/LandingRedirect';
import japaneseIntro from '../components/LandingPage';
import englishIntro from '../components/EnglishLanding';
import Spinner from '../components/Spinner';
import { subscribe, unsubscribe } from '../fetch/PushFetch';
import { pageView } from '../util/tracking';

class RootRouterWrapper extends React.Component {
  state = {
    courses: [],
    pro: false, // for navbar dropdown hover
    setting: false,
    course: false,
    sideNav: false
  };

  // Component가 DOM트리에 추가되기 전에 한번만 호출됩니다. 그렇기 때문에 초기화 처리에 적합합니다.
  componentWillMount() {
    // react는 this.setState 함수가 호출되면 컴포넌트가 리렌더링 되도록 설계 되어 있다.

    this.setState({
      courses: this.props.courses,
      location: this.props.location.pathname
    });
    if (this.props.location.pathname.includes('intro')) {
    } else {
      if (!this.props.jwt) {
        this.props.tryLogin(this.props.isLoggedIn);
      }
      this.props.getCourses();
      this.props.getChatRooms();
    }
    pageView();
  }

  // 컴포넌트가 새로운 props를 전달받을 때 실행된다. 해당 메소드는 초기 렌더링시에는 호출되지 않는다.
  // props를 받아서 state를 변경해야 하는 경우 유용하다.
  // 이 메소드 내부에서 setState를 사용해도 추가적인 렌더링이 발생하지 않는다.
  componentWillReceiveProps(nextProps, nextState) {
    if (nextProps.location.pathname.includes('intro')) {
    } else {
      if (!nextProps.jwt) {
        this.props.tryLogin(nextState.isLoggedIn);
      }
      if (this.state.sideNav) {
        this.setState({
          sideNav: false
        });
      }
      if (!this.state.setting || !this.state.course || !this.state.pro) {
        this.setState({
          pro: false,
          course: false,
          setting: false
        });
      }

      if (!this.props.jwt && nextProps.jwt) {
        this.setState({ userId: nextProps.userId });
        if (!this.props.chatrooms) {
          this.props.getChatRooms();
        }
        if (!this.props.courses) {
          this.props.getCourses();
        }
      }

      if (!this.props.courses && nextProps.courses) {
        this.setState({
          courses: nextProps.courses,
          userState: nextProps.userState,
          courseId: nextProps.courseId
        });

      }

      if (this.state.location !== nextProps.location.pathname) {
        this.setState({ location: nextProps.location.pathname });
      }

      // // for msg subscribe
      if (!this.props.chatrooms && nextProps.chatrooms) {
        if (nextProps.chatrooms.length > 0) {
          console.log('subscribing chatrooms');
          this.props.subscribe(
            `edge-coaching-chatroom-${nextProps.chatroomId}`
          );
        }
      }
    }
  }

  // 다른 lifecycle 메소드와는 달리、true나 falseを 리턴해주어야 합니다.
  // Component가 rerender되기 전에 호출되고、false를 리턴하면 VirtualDOM의 비교를 하지 않고 rerender로 이루어지지 않습니다.
  shouldComponentUpdate(nextProps, nextState) {
    if (!nextProps.courses || !nextProps.chatrooms) {
      return false;
    } else {
      return true;
    }
  }

  onContentClick = courseId => this.props.setContent(courseId);
  // wanted to use this method to prevent duplicate methods
  // but seems like it's not detecting the target well
  // this.setState({[evt.target.name]: false})
  handleProOpen(evt) {
    if (!this.state.location.includes('/premium')) {
      evt.currentTarget.childNodes[0].style = 'color:#6be1cc !important';
    }
    this.setState({ pro: true });
  }
  handleProClose(evt) {
    evt.currentTarget.childNodes[0].style = 'color:#666';
    this.setState({ pro: false });
  }
  dashboardEnter(evt) {
    if (!this.state.location.includes('/dashboard')) {
      evt.currentTarget.style = 'color:#6be1cc';
    }
  }
  dashboardLeave(evt) {
    evt.currentTarget.style = 'color:#666';
  }
  onToggle() {
    // causes error without ontoggle callback on dropdown
  }
  onProClick(evt) {
    evt.currentTarget.parentNode.parentNode.previousSibling.style =
      'color:#fff';
  }
  courseOpen(evt) {
    this.setState({ course: true });
  }
  courseClose(evt) {
    this.setState({ course: false });
  }
  settingOpen(evt) {
    this.setState({ setting: true });
  }
  settingClose(evt) {
    this.setState({ setting: false });
  }
  onSideNavClick(e) {
    this.setState({
      sideNav: !this.state.sideNav
    });
  }

  onCourseClick(evt) {
    this.props.setContent(evt);
    this.props.history.push('/dashboard');
  }

  onLogOut() {
    this.props.unsubscribe(`edge-coaching-chatroom-${this.props.chatroomId}`);
    this.props.logout();
  }

  // render 메서드는 업데이트가 발생할 때마다 호출
  render() {
    let { jwt, courses, pushVisible, coachName } = this.props;

    let handlers = {
      handleProOpen: this.handleProOpen.bind(this),
      handleProClose: this.handleProClose.bind(this),
      onToggle: this.onToggle.bind(this),
      onProClick: this.onProClick.bind(this),
      courseOpen: this.courseOpen.bind(this),
      courseClose: this.courseClose.bind(this),
      settingOpen: this.settingOpen.bind(this),
      settingClose: this.settingClose.bind(this),
      dashboardEnter: this.dashboardEnter.bind(this),
      dashboardLeave: this.dashboardLeave.bind(this),
      onSideNavClick: this.onSideNavClick.bind(this),
      onCourseClick: this.onCourseClick.bind(this),
      onLogOut: this.onLogOut.bind(this)
    };

    if (jwt && courses) {
      return (
        <Switch>
          <Route
            exact
            path='/'
            render={() => (
              <Home
                courses={this.props.courses}
                onClick={this.onContentClick}
              />
            )}
          />
          <Root
            state={this.state}
            handlers={handlers}
            push={pushVisible}
            coachName={coachName}
          >
            <Switch>
              <Route path='/dashboard' component={Dashboard} />
              <Route path='/premium' component={Pro} />
              <Route path='/mypage' component={Profile} />
              <Route path='/forum' component={Forum} />
            </Switch>
          </Root>
        </Switch>
      );
    } else {
      if (this.state.location.includes('intro')) {
        return (
          <Switch>
            <Route exact path='/intro' component={japaneseIntro} />
            <Route exact path='/intro/en' component={englishIntro} />
          </Switch>
        );
      } else {
        return <Spinner />;
      }
    }
  }
}

const mapDispatchToProps = dispatch => {
  return {
    setContent: courseId => {
      dispatch(setContent(courseId));
    },
    logout: () => {
      dispatch(logout());
    },
    tryLogin: () => {
      dispatch(tryLogin());
    },
    getCourses: () => {
      dispatch(getCourses());
    },
    getChatRooms: () => {
      dispatch(getChatRooms());
    },
    subscribe: topic => {
      dispatch(subscribe(topic));
    },
    unsubscribe: topic => {
      dispatch(unsubscribe(topic));
    },
    goToIntroPage: () => {
      let landingPage = 'https://edge.themusio.com/intro';
      if (window.location.href !== landingPage)
        window.location.href = landingPage;
    }
  };
};

const mapStateToProps = (state, props) => {
  return {
    jwt: state.auth.jwtToken, // null
    isLoggedIn: state.auth.isLoggedIn,
    courses: state.auth.courses, // null
    courseId: state.auth.courseId, // null
    userState: state.auth.userState, // null
    userId: state.auth.userEmail, //1
    chatrooms: state.coach.chatrooms, // null
    pushVisible: state.coach.pushVisible, //false
    chatroomId: state.coach.chatroomId, // null
    coachName: state.coach.coachName // null
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(RootRouterWrapper);



// WEBPACK FOOTER //
// ./src/containers/AuthContainer.js